import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';
import LibraryAddRoundedIcon from '@mui/icons-material/LibraryAddRounded';

import { headers, filters } from "./config";

import AddStock from "./Components/AddStock";

const ProductList = () => {

  const [openDialog, setOpenDialog] = useState(false);

  const [productId, setProductId] = useState(null);

  const additionalActions = [
    {
      tooltip: "Add Stock Quantity",
      Icon: LibraryAddRoundedIcon,
      onClick: (id) => {
        setProductId(id);
        setOpenDialog(true);
      },
      color: "info"
    }
  ]

  return (
    <>
    <AddStock open={openDialog} setOpen={setOpenDialog} product_id={productId} setProductId={setProductId} />
    <Table tableId="products" title="Product" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="name" idKey="product_id" fieldsToSearch={["Name", "SKU"]} additionalActions={additionalActions} />
    </>
  );
};

export default ProductList;